import { createContext, ReactNode } from 'react';
import { BoxProps, TabProps as MuiTabProps } from '@mui/material';

export type TabButtonVariant = 'standard' | 'toggleButton';

export type TabType = Omit<MuiTabProps, 'content' | 'title'> & {
  BoxProps?: BoxProps;
  content: ReactNode;
  title: ReactNode;
  value: string;
  wrapperProps?: BoxProps;
};

export type TabContextProviderProps = {
  buttonVariant?: TabButtonVariant;
  onTabChange: (newTab: string) => void;
  selectedTab: string;
  tabs: TabType[];
};

export type TabContextValues = TabContextProviderProps & {
  getContentId: (value: string) => string;
  getLabelId: (value: string) => string;
};

const TabContext = createContext<TabContextValues>({
  getContentId: () => '',
  getLabelId: () => '',
  onTabChange: () => void 0,
  selectedTab: '',
  tabs: [],
});

export default TabContext;
